import React, {Component} from "react"

import Flex from "@irati/ui/src/Flex"
import {H2, Label} from "@irati/ui/src/Typography"
import {RouterLink} from "@irati/ui/src/Link"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"

import {Wrapper} from "./styled"

interface Props extends InjectIntl {
  title: string
  amount: number
  buttonText: string
  page: string
  id: string
  onButtonClick: () => void
}

class BusinessStatisticSection extends Component<Props> {
  render() {
    const {title, amount, buttonText, page, onButtonClick, formatMessage} = this.props
    return (
      <Wrapper>
        <Flex>
          <H2 margin={[2, 0]} color={theme.colors.primary2}>
            {amount}
          </H2>
          <Label small marginTop="auto" marginBottom="auto" marginLeft={theme.spacing.half} color={theme.colors.primary2}>
            {formatMessage({id: title})}
          </Label>
        </Flex>
        <RouterLink id={`${this.props.id}_button`} to={page} cta small onClick={onButtonClick}>
          {formatMessage({id: buttonText})}
        </RouterLink>
      </Wrapper>
    )
  }
}

export default injectIntl(BusinessStatisticSection)
